export const countries = [
  { value: 'USA', label: 'USA', currency: 'USD' },
  { value: 'NL', label: 'Netherlands', currency: 'EUR' },
  { value: 'FR', label: 'France', currency: 'EUR' },
  { value: 'FI', label: 'Finland', currency: 'NOK' },
  { value: 'SWE', label: 'Sweden', currency: 'DKK' },
  { value: 'Canada', label: 'Canada', currency: 'CAD' },
  { value: 'UK', label: 'United Kingdom', currency: 'GBP' },
  { value: 'AU', label: 'Australia', currency: 'AUD' },
  { value: 'SP', label: 'Spain', currency: 'EUR' },
];

export const currencies = [
  {
    value: 'USD',
    label: 'US dollar',
    symbol: '$',
    digitGroupSeparator: ',',
    decimalCharacter: '.',
  },
  {
    value: 'EUR',
    label: 'EURO',
    symbol: '€',
    digitGroupSeparator: '.',
    decimalCharacter: ',',
  },
  {
    value: 'CAD',
    label: 'Canadian dollar',
    symbol: 'C$',
    digitGroupSeparator: ' ',
    decimalCharacter: ',',
  },
  {
    value: 'GBP',
    label: 'Pound sterling',
    symbol: '£',
    digitGroupSeparator: ',',
    decimalCharacter: '.',
  },
  {
    value: 'NOK',
    label: 'Norwegian krone',
    symbol: 'kr',
    digitGroupSeparator: '.',
    decimalCharacter: ',',
  },
  {
    value: 'DKK',
    label: 'Danish Krone',
    symbol: 'kr.',
    digitGroupSeparator: '.',
    decimalCharacter: ',',
  },
  {
    value: 'AUD',
    label: 'Australian dollar',
    symbol: 'A$',
    digitGroupSeparator: ',',
    decimalCharacter: '.',
  },
  {
    value: 'SEK',
    label: 'Swedish krona',
    symbol: 'kr',
    digitGroupSeparator: '.',
    decimalCharacter: ',',
  },
  {
    value: 'ISK',
    label: 'Icelandic Krona',
    symbol: 'kr',
    digitGroupSeparator: '.',
    decimalCharacter: ',',
  },
];

export const defaultCurrency = {
  value: 'USD',
  label: 'US dollar',
  symbol: '$',
  digitGroupSeparator: ',',
  decimalCharacter: '.',
};

export const booleanOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const measurementOptions = [
  { value: 'SquareFootage', label: 'Square Footage' },
  { value: 'SquareMeters', label: 'Square Meters' },
];

export const periodOptions = [
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'SemiAnnually', label: 'Semi Annually' },
  { value: 'Annually', label: 'Annually' },
];

export const guidFormat = '00000000-0000-0000-0000-000000000000';

export const WORKFLOW_OWNER_TYPE = 'ArchWay';

export const DOCUMENT_OWNER_TYPE = 'ArchWay';

export const rootRoute = '/';

export const ACTIONS = {
  create: 'create',
  edit: 'edit',
  view: 'view',
  completeDraft: 'complete',
  completeUWApprove: 'underwriterapproved',
  completeFinalize: 'approved',
  renew: 'renew',
  endorse: 'endorse',
  bind: 'bind',
  copy: 'copy',
  reopen: 'reopen',
  cancel: 'cancel',
};

export const MERGE_WORKFLOW_ACTIONS = {
  MERGE: 1,
  LINK: 2,
  ENDORSEMENT: 3,
};

export const subTabSwitch = {
  portal: `programType==Portal|PortalBindingAgreement`,
  bdx: `programType==BDX|BDXBindingAgreement`,
  ir: `programType==IRThroughArchway`,
  all: '',
};

export const DNQ_TASK_DEFINITION_ID = '421f4bde-2671-423c-9f10-61158b7cec9a';

export const NTU_TASK_DEFINITION_ID = 'deab5980-5879-4d42-ba5e-2400cd82e599';
export const CREATE_POLICY_TASK_DEFINITION_ID =
  '38fc441e-fda7-4d2b-b2c2-99d65df48369';
export const CLEAR_POLICY_TASK_DEFINITION_ID =
  'bb349fd5-96a4-4a11-b8a6-48d132017779';

export const RATING_REQUESTED_TASK_DEFINITION_ID =
  'a25cfdd4-d889-426a-b3d8-55201cd22fad';
export const NEW_HS_SUBMISSION_TASK_DEFINITION_ID =
  '18610496-375e-4ec2-bbcc-5d3423d79314';
export const HS_ATTACHMENT_TASK_DEFINITION_ID =
  'f3ba6d44-0197-4850-bc4f-4b6b926ea7c7';
export const BDX_INSTALLMENT_TASK_DEFINITION_ID =
  'e566ec7f-3922-4560-87fd-b93796f4215d';
export const SPA_DOCUMENT_DATE = '2024-02-20';

export const TEMPLATE_DOCUMENT_LOCATION = 'propfac';
export const SORT_ORDER_DESCENDING = -1;
export const ADD_PRICING_NOTES_PERMISSION = 'wrt:prgpri';
export const installmentTypes = {
  boundBook: 'BoundBook',
  BDX: 'BDX',
};
